export const borders = {
  default: '1px solid',
};
